import React, { useRef } from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { fadeIn } from "../utils/variants";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const PreviousSession = () => {
  const swiperRef = useRef(null);

  const videos = [
    "https://www.youtube.com/embed/plBr91J5JVA?enablejsapi=1",
    "https://www.youtube.com/embed/uJ8mvAJs6BE?enablejsapi=1",
    "https://www.youtube.com/embed/Xv_FNn7L8uA?enablejsapi=1",
    "https://www.youtube.com/embed/M73l2eOtzzw?enablejsapi=1",
  ];

  const goNext = () => swiperRef.current.swiper.slideNext();
  const goPrev = () => swiperRef.current.swiper.slidePrev();

  return (
    <div className="min-h-[600px] flex flex-col items-center justify-center px-2 md:px-4 lg:px-8 bg-gray-50">
      <motion.h2
        className="text-black text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8"
        variants={fadeIn("up", 0.2)}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
      >
        Watch our Previous Session at TECHX Africa
      </motion.h2>

      {/* Navigation arrows */}
      <div className="flex justify-between items-center w-full max-w-6xl mb-6 px-2 sm:px-0">
        <button
          onClick={goPrev}
          className="text-white bg-[#F63A0A] hover:bg-red-600 p-4 rounded-full shadow-lg transition-transform transform hover:scale-110"
        >
          <FiChevronLeft size={28} />
        </button>
        <button
          onClick={goNext}
          className="text-white bg-[#F63A0A] hover:bg-red-600 p-4 rounded-full shadow-lg transition-transform transform hover:scale-110"
        >
          <FiChevronRight size={28} />
        </button>
      </div>

      <Swiper
        ref={swiperRef}
        loop={true}
        spaceBetween={30}
        slidesPerView={1}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1280: { slidesPerView: 2 },
          1536: { slidesPerView: 3 },
        }}
        className="w-full max-w-7xl"
        autoplay={false} 
        allowTouchMove={true} 
      >
        {videos.map((video, index) => (
          <SwiperSlide key={index}>
            <motion.div
              variants={fadeIn("up", index * 0.2)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="rounded-lg shadow-xl overflow-hidden hover:scale-[1.03] transition-transform duration-500"
            >
              <div
                className="w-full"
                style={{
                  height: "350px",
                }}
              >
                <iframe
                  id={`player-${index}`}
                  className="w-full h-full"
                  src={video}
                  title={`Previous Session ${index + 1}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>

      <style jsx>{`
        .swiper-pagination {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default PreviousSession;

